export enum CalendarType {
  SMALL = 'S',
  FULL = 'F',
  MIXTO = 'M',
  NONE = '',
}
